export default "/assets/images/mila-valentine-mobile.webp?f58757ce0870bb762726bf58e852e52c";